import { useEffect, useState } from 'react';
import { fetchActiveCampaign, type PromotionalCampaign } from '../services/contentService';

interface CampaignBannerProps {
  onOpenConsultation: () => void;
}

export function CampaignBanner({ onOpenConsultation }: CampaignBannerProps) {
  const [campaign, setCampaign] = useState<PromotionalCampaign | null>(null);

  useEffect(() => {
    fetchActiveCampaign().then(setCampaign);
  }, []);

  if (!campaign || !campaign.enabled) return null;

  const bgStyle =
    campaign.bannerTheme === 'gold'
      ? 'linear-gradient(135deg, #78350f 0%, #b45309 50%, #92400e 100%)'
      : campaign.bannerTheme === 'emerald'
      ? 'linear-gradient(135deg, #064e3b 0%, #047857 50%, #065f46 100%)'
      : 'linear-gradient(135deg, #07132f 0%, #1e293b 50%, #0f172a 100%)';

  return (
    <div
      style={{
        background: bgStyle,
        color: '#ffffff',
        padding: '10px 16px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
        position: 'relative',
        zIndex: 50,
      }}
    >
      <div
        className="container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '10px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '1.2rem' }}>🎉</span>
          <div>
            <div style={{ fontWeight: 800, fontSize: '0.85rem', letterSpacing: '0.01em', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{campaign.headline}</span>
              {campaign.badgeText && (
                <span
                  style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    fontSize: '0.72rem',
                    fontWeight: 700,
                  }}
                >
                  {campaign.badgeText}
                </span>
              )}
            </div>
            <div style={{ fontSize: '0.78rem', opacity: 0.9, marginTop: '2px' }}>
              {campaign.message}
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={onOpenConsultation}
          style={{
            background: '#ffffff',
            color: '#0f172a',
            border: 'none',
            borderRadius: '6px',
            padding: '6px 14px',
            fontSize: '0.78rem',
            fontWeight: 800,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          }}
        >
          Book Consultation →
        </button>
      </div>
    </div>
  );
}
